var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_list_item"},[_c('img',{attrs:{"src":"/images/ic/etc/ic-tea.svg","alt":""}}),_c('h6',{staticClass:"no-drag --grey60 mt20"},[_vm._v("\n    "+_vm._s(_vm.title === undefined ? _vm.$t('patients.no_patients') : _vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }